import dayjs from "dayjs";
import { SETTLE_LIST_SCOPE } from "./merchantSettleListConstants";

/**
 * @param {import("dayjs").Dayjs[]|null|undefined} dates - RangePicker value [start, end]
 * @returns {string} e.g. "&createdAt=2026-11-01->2026-11-02" or ""
 */
export function createdAtQueryParam(dates) {
  if (!dates?.[0] || !dates?.[1]) return "";
  const range = [dates[0], dates[1]]
    .map((d) => dayjs(d).format("YYYY-MM-DD"))
    .join("->");
  return `&createdAt=${encodeURIComponent(range)}`;
}

/**
 * @param {{ page: number, pageSize: number, createdAt?: import("dayjs").Dayjs[]|null, settleListScope?: string, hasPendingOnly?: boolean }} opts
 * @returns {string} query suffix starting with &
 */
export function buildMerchantSettleListQuery(opts) {
  const parts = [`page=${opts.page}`, `size=${opts.pageSize}`];
  const created = createdAtQueryParam(opts.createdAt);
  if (created) {
    parts.push(created.replace(/^&/, ""));
  }
  const hasPending =
    opts.hasPendingOnly === true ||
    opts.settleListScope === SETTLE_LIST_SCOPE.HAS_PENDING_UNSETTLED;
  if (hasPending) {
    parts.push("hasPending=true");
  }
  return `&${parts.join("&")}`;
}
